/**
 * Product page swatches
 */
window.addEventListener('load', function() {
  frd_product_swatches();
  frd_product_inseam_swatches();
  
  // Update button and div on initial page load after everything is ready
  // Use a single timeout with a reasonable delay to ensure DOM and metafields are ready
  setTimeout(function() {
    if (typeof frd_product === 'undefined' || typeof frd_product_variants_with_metafields === 'undefined') {
      // If not ready, try once more after a delay
      setTimeout(function() {
        if (typeof frd_product !== 'undefined' && typeof frd_product_variants_with_metafields !== 'undefined') {
          // Try to get variant ID from select element first
          let initial_variant_id = null;
          const variant_select = document.querySelector('select[name="id"]');
          if (variant_select && variant_select.value) {
            initial_variant_id = parseInt(variant_select.value);
          } else {
            const url_parameters = new URLSearchParams(window.location.search);
            const url_variant_id = url_parameters.get('variant');
            initial_variant_id = url_variant_id ? parseInt(url_variant_id) : (frd_product.default_variant_id || null);
          }
          if (initial_variant_id) {
            frd_update_preorder_button_and_div(initial_variant_id);
          }
        }
      }, 500);
      return;
    }
    
    // Try to get variant ID from select element first (most reliable)
    let initial_variant_id = null;
    const variant_select = document.querySelector('select[name="id"]');
    if (variant_select && variant_select.value) {
      initial_variant_id = parseInt(variant_select.value);
    } else {
      // Fall back to URL or default
      const url_parameters = new URLSearchParams(window.location.search);
      const url_variant_id = url_parameters.get('variant');
      initial_variant_id = url_variant_id ? parseInt(url_variant_id) : (frd_product.default_variant_id || null);
      console.log('Initial load: Using variant ID from URL/default:', initial_variant_id);
    }
    
    if (initial_variant_id) {
      frd_update_preorder_button_and_div(initial_variant_id);
    }
  }, 800);
});

// Track if we're currently updating to prevent infinite loops
let is_updating_button_text = false;

/**
 * Update Add to Cart button text to UNAVAILABLE when variant is out of stock
 * Checks sold_out span element which is more reliable than Klaviyo button visibility
 */
function frd_hide_add_to_cart_if_klaviyo_visible() {
  // Prevent infinite loops
  if (is_updating_button_text) {
    return;
  }
  
  const soldOutSpan = document.querySelector('.sold_out');
  const add_to_cart_buttons = document.querySelectorAll(".pdp-button-add-to-cart");
  
  if (!add_to_cart_buttons.length || !add_to_cart_buttons[0]) {
    return;
  }
  
  // Check current button text to avoid unnecessary updates
  const current_text = add_to_cart_buttons[0].textContent.trim();
  
  // Check if variant is out of stock by checking sold_out span
  const isOutOfStock = soldOutSpan && 
    soldOutSpan.textContent.trim() !== '' && 
    soldOutSpan.textContent.trim().toUpperCase().includes('UNAVAILABLE');
  
  // Also check Klaviyo button visibility as a fallback
  const klaviyoBisTrigger = document.querySelector('.klaviyo-bis-trigger');
  const klaviyoButtonVisible = klaviyoBisTrigger && 
    window.getComputedStyle(klaviyoBisTrigger).display !== 'none' &&
    klaviyoBisTrigger.offsetParent !== null;
  
  // Only update if variant is out of stock
  if (isOutOfStock || klaviyoButtonVisible) {
    is_updating_button_text = true;
    
    // Update button text to UNAVAILABLE
    const all_button_spans = document.querySelectorAll(".pdp-button-add-to-cart.text");
    all_button_spans.forEach(function(span) {
      span.textContent = "UNAVAILABLE";
    });
    // Also update button data-label attributes
    const all_buttons = document.querySelectorAll(".pdp-button-add-to-cart-btn");
    all_buttons.forEach(function(btn) {
      btn.setAttribute('data-label', "UNAVAILABLE");
    });
    
    // Hide button if Klaviyo button is visible, otherwise show it
    if (klaviyoButtonVisible) {
      // Klaviyo button is visible - hide the UNAVAILABLE button
      add_to_cart_buttons[0].style.display = 'none';
      if (add_to_cart_buttons[0].parentElement) {
        add_to_cart_buttons[0].parentElement.style.display = 'none';
      }
    } else {
      // No Klaviyo button - show the UNAVAILABLE button
      add_to_cart_buttons[0].style.display = 'block';
      if (add_to_cart_buttons[0].parentElement) {
        add_to_cart_buttons[0].parentElement.style.display = 'block';
      }
    }
    
    // Reset flag after a short delay
    setTimeout(function() {
      is_updating_button_text = false;
    }, 50);
  }
}

// Check on page load and periodically to catch dynamically added Klaviyo buttons
window.addEventListener('load', function() {
  setTimeout(frd_hide_add_to_cart_if_klaviyo_visible, 500);
  setTimeout(frd_hide_add_to_cart_if_klaviyo_visible, 1000);
  setTimeout(frd_hide_add_to_cart_if_klaviyo_visible, 2000);
});

// Also observe for changes to the DOM in case Klaviyo button appears later
// Use a debounce to prevent infinite loops
let klaviyoObserverTimeout = null;
if (typeof MutationObserver !== 'undefined') {
  const observer = new MutationObserver(function(mutations) {
    // Only react to changes that aren't from our own button text updates
    let shouldUpdate = false;
    mutations.forEach(function(mutation) {
      // Only update if it's not a textContent change to our buttons
      if (mutation.type === 'childList' || mutation.type === 'attributes') {
        const target = mutation.target;
        // Skip if this is a change to our button text spans
        if (!target.classList || (!target.classList.contains('pdp-button-add-to-cart') && !target.classList.contains('text'))) {
          shouldUpdate = true;
        }
      }
    });
    
    if (shouldUpdate && !is_updating_button_text) {
      // Debounce to prevent infinite loops
      if (klaviyoObserverTimeout) {
        clearTimeout(klaviyoObserverTimeout);
      }
      klaviyoObserverTimeout = setTimeout(function() {
        frd_hide_add_to_cart_if_klaviyo_visible();
      }, 200);
    }
  });
  
  window.addEventListener('load', function() {
    const targetNode = document.querySelector('.purchase-details') || document.body;
    if (targetNode) {
      observer.observe(targetNode, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class']
      });
    }
  });
}

/**
 * Update button text and preorder div based on variant metafields
 */
// Track the last variant ID we processed to avoid unnecessary updates
let last_processed_variant_id = null;
let last_processed_timestamp = 0;
let current_variant_should_show_div = false;
let current_variant_preorder_div_html = '';

// Watch for div removal and re-add if needed
let div_observer = null;
let div_check_interval = null;

// Track button update timeouts to prevent conflicts
let button_update_timeouts = [];

function setup_div_protection() {
  // Clear any existing interval
  if (div_check_interval) {
    clearInterval(div_check_interval);
  }
  
  // Set up periodic check to ensure div exists when it should
  div_check_interval = setInterval(function() {
    if (current_variant_should_show_div && current_variant_preorder_div_html && last_processed_variant_id) {
      const existing_div = document.querySelector('.metafield-available-date[data-variant-id="' + last_processed_variant_id + '"]');
      if (!existing_div) {
        // Div was removed but should exist - re-add it
        console.log('Protection: Div missing for variant', last_processed_variant_id, '- re-adding');
        const purchase_details = document.querySelector('.product .purchase-details') || 
                                 document.querySelector('.purchase-details') ||
                                 document.querySelector('.product_form .purchase-details') ||
                                 document.querySelector('[class*="purchase-details"]');
        if (purchase_details) {
          purchase_details.insertAdjacentHTML('beforebegin', current_variant_preorder_div_html);
        }
      } else {
        // Verify the div is for the current variant (check data attribute)
        const div_variant_id = existing_div.getAttribute('data-variant-id');
        if (div_variant_id && parseInt(div_variant_id) !== last_processed_variant_id) {
          // Div exists but is for wrong variant - remove and re-add correct one
          console.log('Protection: Wrong variant div found, replacing');
          existing_div.remove();
          const purchase_details = document.querySelector('.product .purchase-details') || 
                                   document.querySelector('.purchase-details') ||
                                   document.querySelector('.product_form .purchase-details');
          if (purchase_details && current_variant_preorder_div_html) {
            purchase_details.insertAdjacentHTML('beforebegin', current_variant_preorder_div_html);
          }
        }
        // Also check for any other divs with wrong variant IDs and remove them
        const all_divs = document.querySelectorAll('.metafield-available-date');
        all_divs.forEach(function(div) {
          const check_variant_id = div.getAttribute('data-variant-id');
          if (check_variant_id && parseInt(check_variant_id) !== last_processed_variant_id) {
            console.log('Protection: Removing div for wrong variant:', check_variant_id);
            div.remove();
          }
        });
      }
    } else if (!current_variant_should_show_div) {
      // If we shouldn't show div, make sure ALL divs are removed
      const all_divs_to_remove = document.querySelectorAll('.metafield-available-date');
      all_divs_to_remove.forEach(function(div) {
        div.remove();
      });
    }
  }, 200); // Check every 200ms for faster recovery
  
  // Also use MutationObserver for immediate detection
  if (typeof MutationObserver !== 'undefined') {
    if (div_observer) {
      div_observer.disconnect();
    }
    
    div_observer = new MutationObserver(function(mutations) {
      // Check if our div was removed or changed
      if (current_variant_should_show_div && current_variant_preorder_div_html && last_processed_variant_id) {
        const existing_div = document.querySelector('.metafield-available-date[data-variant-id="' + last_processed_variant_id + '"]');
        if (!existing_div) {
          // Div was removed but should exist - re-add it immediately
          console.log('MutationObserver: Div removed for variant', last_processed_variant_id, '- re-adding');
          const purchase_details = document.querySelector('.product .purchase-details') || 
                                   document.querySelector('.purchase-details') ||
                                   document.querySelector('.product_form .purchase-details') ||
                                   document.querySelector('[class*="purchase-details"]');
          if (purchase_details) {
            purchase_details.insertAdjacentHTML('beforebegin', current_variant_preorder_div_html);
          }
        } else {
          // Verify div is for correct variant (should always be correct since we're querying by variant ID)
          // But check for any other divs with wrong variant IDs and remove them
          const all_divs = document.querySelectorAll('.metafield-available-date');
          all_divs.forEach(function(div) {
            const check_variant_id = div.getAttribute('data-variant-id');
            if (check_variant_id && parseInt(check_variant_id) !== last_processed_variant_id) {
              console.log('MutationObserver: Removing div for wrong variant:', check_variant_id);
              div.remove();
            }
          });
        }
      }
    });
    
    // Start observing when DOM is ready
    const targetNode = document.querySelector('.product .purchase-details') || 
                      document.querySelector('.purchase-details') ||
                      document.body;
    if (targetNode) {
      div_observer.observe(targetNode, {
        childList: true,
        subtree: true
      });
    }
  }
}

// Initialize protection on page load
window.addEventListener('load', function() {
  setTimeout(setup_div_protection, 1000);
});

function frd_update_preorder_button_and_div(variantId) {
  // Make sure variantId is valid
  if (!variantId || isNaN(variantId)) {
    return;
  }
  
  // Skip if we just processed this variant within the last 100ms (prevent rapid duplicate calls)
  const now = Date.now();
  if (last_processed_variant_id === variantId && (now - last_processed_timestamp) < 100) {
    return;
  }
  
  const add_to_cart_buttons = document.querySelectorAll(".pdp-button-add-to-cart");
  const purchase_details_div = document.querySelector('.product .purchase-details');
  const active_available_date_div = document.querySelector('.metafield-available-date');
  
  // Get metafields for this variant
  if (typeof frd_product_variants_with_metafields === 'undefined') {
    return;
  }
  
  // Try to get the actual selected variant ID from the form select element (more reliable)
  // Always prioritize the select element value as it's the source of truth
  let actual_variant_id = variantId;
  const variant_select = document.querySelector('select[name="id"]');
  if (variant_select && variant_select.value) {
    actual_variant_id = parseInt(variant_select.value);
    // Update variantId to match so all subsequent logic uses the correct ID
    variantId = actual_variant_id;
  }
  
  // FIRST: Check if current variant has preorder_image metafield
  // We'll check this later, but for now remove divs that don't match current variant
  const all_existing_divs_before = document.querySelectorAll('.metafield-available-date');
  all_existing_divs_before.forEach(function(div) {
    const div_variant_id = div.getAttribute('data-variant-id');
    const has_preorder_image = div.querySelector('.metafield-preorder-image');
    
    // Remove if it's for a different variant
    if (div_variant_id && parseInt(div_variant_id) !== actual_variant_id) {
      div.remove();
    } else if (has_preorder_image && (!div_variant_id || parseInt(div_variant_id) !== actual_variant_id)) {
      // Remove preorder image divs that don't match current variant (including Liquid-rendered ones without variant ID)
      div.remove();
    }
  });
  
  // Try both string and number keys (in case of type mismatch)
  const variantIdStr = String(actual_variant_id);
  const variantIdNum = parseInt(actual_variant_id);
  let frd_pdp_variant_metafields = frd_product_variants_with_metafields[variantIdNum] || 
                                    frd_product_variants_with_metafields[variantIdStr] || 
                                    frd_product_variants_with_metafields[actual_variant_id] || 
                                    {};
  
  
  // Initialize metafields object if it doesn't exist (create a copy so we don't modify the original)
  if (!frd_pdp_variant_metafields || Object.keys(frd_pdp_variant_metafields).length === 0) {
    frd_pdp_variant_metafields = {};
  } else {
    // Create a copy to avoid modifying the original object
    frd_pdp_variant_metafields = Object.assign({}, frd_pdp_variant_metafields);
  }
  
  // Check if this variant exists in the metafields object (has any data)
  const variant_exists_in_object = frd_pdp_variant_metafields && 
                                   Object.keys(frd_pdp_variant_metafields).length > 0 &&
                                   (frd_pdp_variant_metafields.preorder_image !== undefined || 
                                    frd_pdp_variant_metafields.availability_date !== undefined ||
                                    frd_pdp_variant_metafields.quantity !== undefined);
  
  // Find matching div - first try variant ID, then try any div (Liquid-rendered divs don't have data-variant-id)
  let matching_div = document.querySelector('.metafield-available-date[data-variant-id="' + actual_variant_id + '"]');
  
  // If not found, try to find any div with availability_date text (Liquid-rendered divs don't have data-variant-id)
  if (!matching_div) {
    const all_metafield_divs = document.querySelectorAll('.metafield-available-date');
    for (let i = 0; i < all_metafield_divs.length; i++) {
      const div = all_metafield_divs[i];
      const has_availability_date = div.querySelector('.estimated-ship-date-text');
      const has_preorder_image = div.querySelector('.metafield-preorder-image');
      // Only use divs that have availability_date (not preorder_image)
      if (has_availability_date && !has_preorder_image) {
        matching_div = div;
        break;
      }
    }
  }
  
  // Always try to read availability_date from DOM if it's missing from metafields object
  // This is safe because availability_date is text and won't cause issues with stale images
  if ((!frd_pdp_variant_metafields.availability_date || 
      frd_pdp_variant_metafields.availability_date === '' || 
      frd_pdp_variant_metafields.availability_date === 'undefined' ||
      frd_pdp_variant_metafields.availability_date === undefined) && matching_div) {
    const availability_date_text = matching_div.querySelector('.estimated-ship-date-text');
    if (availability_date_text) {
      const text_content = availability_date_text.textContent;
      // Extract the date from the text (format: "This item is currently on backorder with an estimated ship date of: [DATE]")
      const date_match = text_content.match(/estimated ship date of:\s*(.+)/i);
      if (date_match && date_match[1]) {
        const availability_date_value = date_match[1].trim();
        frd_pdp_variant_metafields.availability_date = availability_date_value;
        // Also update the original metafields object so it persists for future lookups
        if (!frd_product_variants_with_metafields[actual_variant_id]) {
          frd_product_variants_with_metafields[actual_variant_id] = {};
        }
        frd_product_variants_with_metafields[actual_variant_id].availability_date = availability_date_value;
        // Also update for string/number key variants
        frd_product_variants_with_metafields[variantIdStr] = frd_product_variants_with_metafields[variantIdStr] || {};
        frd_product_variants_with_metafields[variantIdStr].availability_date = availability_date_value;
        frd_product_variants_with_metafields[variantIdNum] = frd_product_variants_with_metafields[variantIdNum] || {};
        frd_product_variants_with_metafields[variantIdNum].availability_date = availability_date_value;
        
        // Update the copy as well so it's available immediately
        frd_pdp_variant_metafields.availability_date = availability_date_value;
      }
    }
  }
  
  // Only read preorder_image from DOM if variant doesn't exist in metafields object
  // IMPORTANT: If variant exists in object, trust the object completely for preorder_image
  // This prevents reading stale image data from previous variants' divs
  if (!variant_exists_in_object && matching_div) {
    // Only read preorder_image from DOM if it's missing
    if (frd_pdp_variant_metafields.preorder_image === undefined || 
        frd_pdp_variant_metafields.preorder_image === null) {
      const preorder_img = matching_div.querySelector('.metafield-preorder-image img');
      if (preorder_img && preorder_img.src) {
        frd_pdp_variant_metafields.preorder_image = preorder_img.src;
      } else {
        // If the div exists but has no image, explicitly set to empty string
        frd_pdp_variant_metafields.preorder_image = '';
      }
    }
  } else if (variant_exists_in_object) {
    // Variant exists in metafields object - trust it completely for preorder_image
    // If preorder_image is an empty string, treat it as "no image"
  }
  
  // Re-read from original object in case we stored data there (to ensure we have the latest)
  // This is important because we might have stored availability_date in the original object
  const stored_metafields = frd_product_variants_with_metafields[variantIdNum] || 
                            frd_product_variants_with_metafields[variantIdStr] || 
                            frd_product_variants_with_metafields[actual_variant_id] || 
                            {};
  
  // Merge stored data with our copy (stored data takes precedence)
  if (stored_metafields.availability_date) {
    frd_pdp_variant_metafields.availability_date = stored_metafields.availability_date;
  }
  if (stored_metafields.preorder_image !== undefined) {
    frd_pdp_variant_metafields.preorder_image = stored_metafields.preorder_image;
  }
  if (stored_metafields.quantity !== undefined) {
    frd_pdp_variant_metafields.quantity = stored_metafields.quantity;
  }
  if (stored_metafields.button_text !== undefined) {
    frd_pdp_variant_metafields.button_text = stored_metafields.button_text;
  }
  
  // Update variantId to the actual one we found
  variantId = actual_variant_id;
  
  const frd_pdp_variant_preorder_image = frd_pdp_variant_metafields ? frd_pdp_variant_metafields.preorder_image : undefined;
  const frd_pdp_variant_availability_date = frd_pdp_variant_metafields ? frd_pdp_variant_metafields.availability_date : undefined;
  const frd_pdp_variant_button_text = frd_pdp_variant_metafields ? frd_pdp_variant_metafields.button_text : undefined;
  
  // Step 1: Check availability_date metafield first
  let has_availability_date = false;
  if (frd_pdp_variant_availability_date !== undefined && frd_pdp_variant_availability_date !== null) {
    const availability_date_str = String(frd_pdp_variant_availability_date).trim();
    has_availability_date = availability_date_str !== '' && 
      availability_date_str !== 'undefined' && 
      availability_date_str !== 'null';
  }
  
  // Step 2: Check preorder_image metafield
  const has_preorder_image = frd_pdp_variant_preorder_image && 
    typeof frd_pdp_variant_preorder_image === 'string' && 
    frd_pdp_variant_preorder_image.trim() !== '' && 
    frd_pdp_variant_preorder_image.trim() !== 'undefined' && 
    frd_pdp_variant_preorder_image.trim() !== 'null';
  
  // If current variant doesn't have preorder_image, remove ALL preorder image divs immediately
  if (!has_preorder_image) {
    const all_preorder_divs = document.querySelectorAll('.metafield-available-date');
    all_preorder_divs.forEach(function(div) {
      const has_preorder_img = div.querySelector('.metafield-preorder-image');
      if (has_preorder_img) {
        div.remove();
      }
    });
  }
  
  // Step 3: Determine what to show
  // Only show preorder_image div (availability_date div is not shown, but button text still changes)
  const should_show_preorder_image = has_preorder_image;
  const should_show_availability_date = false; // Don't show div, but use for button text
  const should_show_anything = should_show_preorder_image; // Only check preorder_image for button text
  
  // Add CSS class to .size-chart-grid-item-1 if variant has preorder image metafield
  // Note: Repositioning will happen after preorder div is inserted
  const size_chart_item = document.querySelector('.size-chart-grid-item-1');
  const size_chart_grid_item = size_chart_item ? size_chart_item.closest('.size-chart-grid-item') : null;
  const size_chart_grid = size_chart_item ? size_chart_item.closest('.size-chart-grid') : null;
  
  // Function to move Color/Size back to its original position
  const moveColorSizeBack = function() {
    if (size_chart_grid && size_chart_grid_item && size_chart_grid_item.parentElement !== size_chart_grid) {
      // Element is not in its original position, move it back
      size_chart_grid.appendChild(size_chart_grid_item);
      // Ensure the element is properly reset - remove any inline styles that might interfere
      if (size_chart_item) {
        size_chart_item.style.position = '';
        size_chart_item.style.marginLeft = '';
        size_chart_item.style.marginTop = '';
        size_chart_item.style.marginBottom = '';
      }
    }
  };
  
  // Function to reposition Color/Size element after preorder image
  const repositionColorSize = function() {
    // Only reposition if variant has preorder image
    if (!has_preorder_image) {
      // No preorder image, ensure element is back in original position
      moveColorSizeBack();
      return;
    }
    
    const purchase_details = document.querySelector('.purchase-details');
    const purchase_details_buttons = document.querySelector('.purchase-details__buttons');
    
    if (size_chart_item && purchase_details && purchase_details_buttons && size_chart_grid_item) {
      // Find the preorder image div to position Color/Size after it
      const preorder_image_div = purchase_details.querySelector('.metafield-available-date[data-metafield-type="preorder-image"]');
      if (preorder_image_div) {
        // Move Color/Size to be after preorder image but before buttons
        if (size_chart_grid_item.parentElement !== purchase_details) {
          // Not in purchase-details yet, insert after preorder image
          preorder_image_div.insertAdjacentElement('afterend', size_chart_grid_item);
        } else {
          // Already in purchase-details, but make sure it's after preorder image
          if (size_chart_grid_item.compareDocumentPosition(preorder_image_div) & Node.DOCUMENT_POSITION_FOLLOWING) {
            // Color/Size is before preorder image, need to move it after
            preorder_image_div.insertAdjacentElement('afterend', size_chart_grid_item);
          }
        }
      } else if (size_chart_grid_item.parentElement !== purchase_details) {
        // Preorder image not found yet, but still move Color/Size before buttons as fallback
        purchase_details.insertBefore(size_chart_grid_item, purchase_details_buttons);
      }
    }
  };
  
  if (size_chart_item) {
    if (has_preorder_image) {
      size_chart_item.classList.add('has-preorder-image');
    } else {
      size_chart_item.classList.remove('has-preorder-image');
      // Immediately move it back to its original position in size-chart-grid if it was moved
      moveColorSizeBack();
    }
  }
  
  // Check if div already exists and matches what we want to show
  // Only check for preorder_image divs (we don't show availability_date divs)
  let should_remove_div = true;
  let div_already_correct = false;
  
  if (active_available_date_div && should_show_preorder_image) {
    // Check if existing div shows the correct preorder image
    const existing_image = active_available_date_div.querySelector('.metafield-preorder-image img');
    const has_preorder_class = active_available_date_div.querySelector('.has-preorder-image-metafield');
    if (existing_image && has_preorder_class && existing_image.src === frd_pdp_variant_preorder_image) {
      should_remove_div = false;
      div_already_correct = true;
    }
  }
  
  // Build preorder div based on what we should show
  let preorder_div = '';
  if (should_show_preorder_image) {
    // Show preorder image (if both exist, only show image)
    preorder_div = `
      <div class="metafield-available-date" data-variant-id="${variantId}" data-metafield-type="preorder-image">
        <div class="estimated-ship-date has-preorder-image-metafield">
          <div class="metafield-preorder-image">
            <img src="${frd_pdp_variant_preorder_image}">
          </div>
        </div>
      </div>
    `;
  } else if (should_show_availability_date) {
    // Show availability date (only if no preorder image)
    const availability_date_value = frd_pdp_variant_availability_date || '';
    preorder_div = `
      <div class="metafield-available-date" data-variant-id="${variantId}" data-metafield-type="availability-date">
        <div class="estimated-ship-date has-available-date-metafield">
          <p id="available-date-metafield" class="estimated-ship-date-text">
            This item is currently on backorder with an estimated ship date of: ${availability_date_value}
          </p>
        </div>
      </div>
    `;
  }
  
  // Store state for MutationObserver and protection
  // IMPORTANT: Set these BEFORE any DOM manipulation to ensure protection works correctly
  // Only track div state if we're actually showing a div (preorder_image), not just for button text
  current_variant_should_show_div = should_show_preorder_image && !!preorder_div;
  current_variant_preorder_div_html = preorder_div;
  
  // Set up protection immediately if we should show the div (only for preorder_image)
  if (should_show_preorder_image && preorder_div) {
    // Clear any existing protection first
    if (div_check_interval) {
      clearInterval(div_check_interval);
      div_check_interval = null;
    }
    if (div_observer) {
      div_observer.disconnect();
      div_observer = null;
    }
    // Set up protection immediately
    setup_div_protection();
  } else {
    // If we shouldn't show div, clear protection
    current_variant_should_show_div = false;
    current_variant_preorder_div_html = '';
    if (div_check_interval) {
      clearInterval(div_check_interval);
      div_check_interval = null;
    }
  }
  
  // Check if variant is out of stock by checking sold_out span element
  // This is more reliable than checking Klaviyo button visibility
  const soldOutSpan = document.querySelector('.sold_out');
  const isVariantOutOfStock = soldOutSpan && 
    soldOutSpan.textContent.trim() !== '' && 
    soldOutSpan.textContent.trim().toUpperCase().includes('UNAVAILABLE');
  
  // Also check Klaviyo button visibility as a fallback
  const klaviyoBisTrigger = document.querySelector('.klaviyo-bis-trigger');
  const klaviyoButtonVisible = klaviyoBisTrigger && 
    window.getComputedStyle(klaviyoBisTrigger).display !== 'none' &&
    klaviyoBisTrigger.offsetParent !== null;
  
  // Variant is out of stock if sold_out span shows UNAVAILABLE or Klaviyo button is visible
  const isOutOfStock = isVariantOutOfStock || klaviyoButtonVisible;
  
  // Update button text FIRST, before div logic (so it happens regardless)
  // Clear any existing button update timeouts to prevent conflicts
  button_update_timeouts.forEach(function(timeout) {
    clearTimeout(timeout);
  });
  button_update_timeouts = [];
  
  // Function to update all add to cart button text (both regular and sticky)
  const updateAllButtonText = function(text) {
    const all_button_spans = document.querySelectorAll(".pdp-button-add-to-cart.text");
    all_button_spans.forEach(function(span) {
      span.textContent = text;
    });
    // Also update button data-label attributes
    const all_buttons = document.querySelectorAll(".pdp-button-add-to-cart-btn");
    all_buttons.forEach(function(btn) {
      btn.setAttribute('data-label', text);
    });
  };
  
  if (add_to_cart_buttons && add_to_cart_buttons.length > 0 && add_to_cart_buttons[0]) {
    // Determine button text: UNAVAILABLE if out of stock, custom.button_text if set, PREORDER if has preorder_image, else ADD TO CART
    let button_text;
    let should_show_button = true;
    
    // Check if custom button text is set and valid
    const has_custom_button_text = frd_pdp_variant_button_text && 
      typeof frd_pdp_variant_button_text === 'string' && 
      frd_pdp_variant_button_text.trim() !== '' && 
      frd_pdp_variant_button_text.trim() !== 'undefined' && 
      frd_pdp_variant_button_text.trim() !== 'null';
    
    if (isOutOfStock) {
      // Out of stock - show UNAVAILABLE, but hide if Klaviyo button is visible (ignore custom.button_text)
      if (klaviyoButtonVisible) {
        // Klaviyo button is visible - hide the UNAVAILABLE button
        button_text = "UNAVAILABLE";
        should_show_button = false;
      } else {
        // No Klaviyo button - show UNAVAILABLE button
        button_text = "UNAVAILABLE";
        should_show_button = true;
      }
    } else if (has_custom_button_text) {
      // Custom button text is set and variant is in stock - use custom text
      // This overrides both PREORDER and ADD TO CART
      button_text = frd_pdp_variant_button_text.trim();
      should_show_button = true;
    } else if (should_show_anything) {
      // Has preorder_image metafield and in stock - show PREORDER
      button_text = "PREORDER";
      should_show_button = true;
    } else {
      // No preorder_image metafield and in stock - show ADD TO CART
      button_text = "ADD TO CART";
      should_show_button = true;
    }
    
    // Update button text
    updateAllButtonText(button_text);
    
    // Show or hide buttons based on logic
    // Note: Sticky button (#sticky-atc) visibility is controlled by CSS and IntersectionObserver, so we only update regular buttons
    add_to_cart_buttons.forEach(function(buttonSpan) {
      // Skip sticky button - let CSS and IntersectionObserver handle its visibility
      // Check if this span is inside the sticky button
      const parentButton = buttonSpan.closest('button');
      if (parentButton && parentButton.id === 'sticky-atc') {
        return;
      }
      
      if (should_show_button) {
        buttonSpan.style.display = 'block';
        if (buttonSpan.parentElement) {
          buttonSpan.parentElement.style.display = 'block';
        }
      } else {
        buttonSpan.style.display = 'none';
        if (buttonSpan.parentElement) {
          buttonSpan.parentElement.style.display = 'none';
        }
      }
    });
    
    // Set up persistent button text update
    // This function checks the current variant and updates button text accordingly
    const updateButtonText = function() {
      // Get the current variant ID
      const current_select = document.querySelector('select[name="id"]');
      let current_variant_id = null;
      if (current_select && current_select.value) {
        current_variant_id = parseInt(current_select.value);
      } else {
        const url_params = new URLSearchParams(window.location.search);
        const url_variant = url_params.get('variant');
        if (url_variant) {
          current_variant_id = parseInt(url_variant);
        }
      }
      
      // If no variant ID found, don't update
      if (!current_variant_id) {
        return;
      }
      
      // Check current variant's metafields (try both string and number keys)
      const current_variant_id_str = String(current_variant_id);
      const current_variant_id_num = parseInt(current_variant_id);
      const current_metafields = frd_product_variants_with_metafields[current_variant_id_num] || 
                                  frd_product_variants_with_metafields[current_variant_id_str] || 
                                  frd_product_variants_with_metafields[current_variant_id] || 
                                  {};
      const has_preorder_img = current_metafields.preorder_image && 
        typeof current_metafields.preorder_image === 'string' && 
        current_metafields.preorder_image.trim() !== '' && 
        current_metafields.preorder_image.trim() !== 'undefined' &&
        current_metafields.preorder_image.trim() !== 'null';
      
      // Check if custom button text is set and valid
      const has_custom_button_text = current_metafields.button_text && 
        typeof current_metafields.button_text === 'string' && 
        current_metafields.button_text.trim() !== '' && 
        current_metafields.button_text.trim() !== 'undefined' && 
        current_metafields.button_text.trim() !== 'null';
      
      const btn = document.querySelectorAll(".pdp-button-add-to-cart")[0];
      if (!btn) return;
      
      // Check if variant is out of stock by checking sold_out span element
      const sold_out_check = document.querySelector('.sold_out');
      const is_out_of_stock_span = sold_out_check && 
        sold_out_check.textContent.trim() !== '' && 
        sold_out_check.textContent.trim().toUpperCase().includes('UNAVAILABLE');
      
      // Also check Klaviyo button visibility as a fallback
      const klaviyo_check = document.querySelector('.klaviyo-bis-trigger');
      const klaviyo_visible = klaviyo_check && 
        window.getComputedStyle(klaviyo_check).display !== 'none' &&
        klaviyo_check.offsetParent !== null;
      
      // Variant is out of stock if sold_out span shows UNAVAILABLE or Klaviyo button is visible
      const is_out_of_stock = is_out_of_stock_span || klaviyo_visible;
      
      // Determine button text: UNAVAILABLE if out of stock, custom.button_text if set, PREORDER if has preorder_image, else ADD TO CART
      let expected_text;
      let should_show_btn = true;
      
      if (is_out_of_stock) {
        expected_text = "UNAVAILABLE";
        // Hide button if Klaviyo button is visible, otherwise show it (ignore custom.button_text when out of stock)
        if (klaviyo_visible) {
          should_show_btn = false;
        } else {
          should_show_btn = true;
        }
      } else if (has_custom_button_text) {
        // Custom button text is set and variant is in stock - use custom text
        // This overrides both PREORDER and ADD TO CART
        expected_text = current_metafields.button_text.trim();
        should_show_btn = true;
      } else if (has_preorder_img) {
        expected_text = "PREORDER";
        should_show_btn = true;
      } else {
        expected_text = "ADD TO CART";
        should_show_btn = true;
      }
      
      // Show or hide buttons based on logic
      // Note: Sticky button (#sticky-atc) visibility is controlled by CSS and IntersectionObserver, so we only update regular buttons
      const all_buttons_to_update = document.querySelectorAll(".pdp-button-add-to-cart");
      all_buttons_to_update.forEach(function(buttonSpan) {
        // Skip sticky button - let CSS and IntersectionObserver handle its visibility
        // Check if this span is inside the sticky button
        const parentButton = buttonSpan.closest('button');
        if (parentButton && parentButton.id === 'sticky-atc') {
          return;
        }
        
        if (should_show_btn) {
          buttonSpan.style.display = 'block';
          if (buttonSpan.parentElement) {
            buttonSpan.parentElement.style.display = 'block';
          }
        } else {
          buttonSpan.style.display = 'none';
          if (buttonSpan.parentElement) {
            buttonSpan.parentElement.style.display = 'none';
          }
        }
      });
      
      // Update all button text
      const all_button_spans = document.querySelectorAll(".pdp-button-add-to-cart.text");
      all_button_spans.forEach(function(span) {
        if (span.textContent.trim() !== expected_text) {
          span.textContent = expected_text;
        }
      });
      // Also update button data-label attributes
      const all_buttons = document.querySelectorAll(".pdp-button-add-to-cart-btn");
      all_buttons.forEach(function(btn) {
        btn.setAttribute('data-label', expected_text);
      });
    };
    // Use longer delays to ensure Klaviyo script has time to update button visibility
    button_update_timeouts.push(setTimeout(updateButtonText, 100));
    button_update_timeouts.push(setTimeout(updateButtonText, 300));
    button_update_timeouts.push(setTimeout(updateButtonText, 600));
    button_update_timeouts.push(setTimeout(updateButtonText, 1000));
    button_update_timeouts.push(setTimeout(updateButtonText, 1500));
    button_update_timeouts.push(setTimeout(updateButtonText, 2000));
    button_update_timeouts.push(setTimeout(updateButtonText, 3000));
  }
  
  // Update UI based on metafields (div logic)
  // Only show divs for preorder_image, not availability_date
  if (should_show_preorder_image) {
    // Remove ALL existing divs (including Liquid-rendered ones without data-variant-id)
    // We'll insert our own div with the correct variant ID
    const all_existing_divs = document.querySelectorAll('.metafield-available-date');
    all_existing_divs.forEach(function(div) {
      const div_variant_id = div.getAttribute('data-variant-id');
      const has_availability_date_text = div.querySelector('.estimated-ship-date-text');
      // Remove if it's for a different variant, or if it doesn't have variant ID (Liquid-rendered), or if we need to change content
      if (div_variant_id && parseInt(div_variant_id) !== variantId) {
        // Different variant - remove it
        div.remove();
      } else if (!div_variant_id && has_availability_date_text) {
        // Liquid-rendered div with availability_date (no preorder_image) - hide it instead of removing
        // We've already read the availability_date from it, so we can safely hide it
        div.style.display = 'none';
      } else if (!div_variant_id) {
        // Liquid-rendered div without variant ID - remove it (we'll create our own)
        div.remove();
      } else if (should_remove_div && !div_already_correct) {
        // Same variant but content needs to change
        div.remove();
      }
    });
    
    // Insert preorder div - only if div doesn't already exist or was removed
    // Check again after potential removal
    const current_div_check = document.querySelector('.metafield-available-date[data-variant-id="' + variantId + '"]');
    if (preorder_div && !div_already_correct && !current_div_check) {
      // Try multiple selectors to find purchase_details_div
      let target_div = purchase_details_div;
      if (!target_div) {
        target_div = document.querySelector('.purchase-details');
      }
      if (!target_div) {
        target_div = document.querySelector('.product_form .purchase-details');
      }
      
      if (target_div) {
        // Insert preorder image at the beginning of purchase-details (before Color/Size and buttons)
        target_div.insertAdjacentHTML('afterbegin', preorder_div);
        
        // Reposition Color/Size element after preorder image
        setTimeout(repositionColorSize, 0);
        
        // Verify div was inserted and set up immediate protection
        setTimeout(function() {
          const verify_div = document.querySelector('.metafield-available-date[data-variant-id="' + variantId + '"]');
          if (!verify_div && preorder_div && current_variant_should_show_div && last_processed_variant_id === variantId) {
            console.log('Div was removed immediately after insertion, re-adding for variant:', variantId);
            const check_target = document.querySelector('.product .purchase-details') || 
                                document.querySelector('.purchase-details') ||
                                document.querySelector('.product_form .purchase-details');
            if (check_target) {
              check_target.insertAdjacentHTML('afterbegin', preorder_div);
              setTimeout(repositionColorSize, 0);
            }
          }
        }, 100);
        
        // Add delayed checks to ensure div stays (in case other scripts remove it)
        setTimeout(function() {
          const existing_div_check = document.querySelector('.metafield-available-date[data-variant-id="' + variantId + '"]');
          if (!existing_div_check && preorder_div && current_variant_should_show_div && last_processed_variant_id === variantId) {
            const check_target = document.querySelector('.product .purchase-details') || 
                                document.querySelector('.purchase-details') ||
                                document.querySelector('.product_form .purchase-details');
            if (check_target) {
              check_target.insertAdjacentHTML('afterbegin', preorder_div);
              setTimeout(repositionColorSize, 0);
            }
          }
        }, 500);
        setTimeout(function() {
          const existing_div_check = document.querySelector('.metafield-available-date[data-variant-id="' + variantId + '"]');
          if (!existing_div_check && preorder_div && current_variant_should_show_div && last_processed_variant_id === variantId) {
            const check_target = document.querySelector('.product .purchase-details') || 
                                document.querySelector('.purchase-details') ||
                                document.querySelector('.product_form .purchase-details');
            if (check_target) {
              check_target.insertAdjacentHTML('afterbegin', preorder_div);
              setTimeout(repositionColorSize, 0);
            }
          }
        }, 1000);
        setTimeout(function() {
          const existing_div_check = document.querySelector('.metafield-available-date[data-variant-id="' + variantId + '"]');
          if (!existing_div_check && preorder_div && current_variant_should_show_div && last_processed_variant_id === variantId) {
            const check_target = document.querySelector('.product .purchase-details') || 
                                document.querySelector('.purchase-details') ||
                                document.querySelector('.product_form .purchase-details');
            if (check_target) {
              check_target.insertAdjacentHTML('afterbegin', preorder_div);
              setTimeout(repositionColorSize, 0);
            }
          }
        }, 2000);
      } else {
        // If still not found, retry with multiple attempts
        // Store preorder_div in a variable that persists in the closure
        const preorder_div_to_insert = preorder_div;
        let retry_count = 0;
        const max_retries = 10;
        const retry_interval = setInterval(function() {
          retry_count++;
          const retry_target_div = document.querySelector('.product .purchase-details') || 
                                   document.querySelector('.purchase-details') ||
                                   document.querySelector('.product_form .purchase-details') ||
                                   document.querySelector('[class*="purchase-details"]');
          
          const existing_div_check = document.querySelector('.metafield-available-date[data-variant-id="' + variantId + '"]');
          if (retry_target_div && !existing_div_check && preorder_div_to_insert && current_variant_should_show_div && last_processed_variant_id === variantId) {
            retry_target_div.insertAdjacentHTML('afterbegin', preorder_div_to_insert);
            setTimeout(repositionColorSize, 0);
            clearInterval(retry_interval);
          } else if (retry_count >= max_retries) {
            clearInterval(retry_interval);
          }
        }, 100);
      }
    }
  } else {
    // Not showing preorder_image div (might have availability_date for button text, but no div)
    current_variant_should_show_div = false;
    current_variant_preorder_div_html = '';
    
    // Ensure Color/Size element is back in its original position when no preorder image
    moveColorSizeBack();
    
    // Hide/remove all metafield divs (including availability_date divs - we don't show them anymore)
    const all_metafield_divs_to_remove = document.querySelectorAll('.metafield-available-date');
    all_metafield_divs_to_remove.forEach(function(div) {
      const div_variant_id = div.getAttribute('data-variant-id');
      const has_availability_date_text = div.querySelector('.estimated-ship-date-text');
      const has_preorder_image = div.querySelector('.metafield-preorder-image');
      
      // Always remove preorder image divs when switching to variants without preorder_image
      if (has_preorder_image) {
        div.remove();
      } else if (!div_variant_id && has_availability_date_text) {
        // Hide Liquid-rendered availability_date divs instead of removing (we've already read the data)
        div.style.display = 'none';
      } else {
        // Remove JavaScript-generated divs or other divs
        div.remove();
      }
    });
    
    // Also clear the protection interval since we don't need it anymore
    if (div_check_interval) {
      clearInterval(div_check_interval);
      div_check_interval = null;
    }
  }
  
  // Mark this variant as processed
  last_processed_variant_id = variantId;
  last_processed_timestamp = Date.now();
}

function frd_product_swatches() {
  const frd_pdp_product_handle = frd_product.handle;
  let frd_pdp_variant_id = frd_product.default_variant_id;
  const frd_pdp_variant_title = document.querySelector('.size-chart-grid-item-1 span');
  const frd_pdp_variant_swatches = document.querySelectorAll('.swatch_options .swatch-element');

  // Update variant title
  if (frd_pdp_variant_title) {
  frd_pdp_variant_title.innerText = frd_product.default_variant_title;
  }

  // Loop variants
  frd_pdp_variant_swatches.forEach((frd_pdp_variant_swatch, index) => {

    // Add listener to each variant
    frd_pdp_variant_swatch.addEventListener('click', (event) => {
      // Don't hide the button here - let frd_update_preorder_button_and_div() handle visibility
      // This ensures the button is always properly shown/hidden based on variant state
      
      // Get variant data
      fetch('/products/' + frd_pdp_product_handle + '.js').then(function(response) {
        return response.json();
      }).then(function(product) {
        // Query buttons fresh inside the callback
        const add_to_cart_buttons = document.querySelectorAll(".pdp-button-add-to-cart");
        
        // Get variant ID from select element first (most reliable after click)
        let frd_pdp_variant_id = null;
        const variant_select = document.querySelector('select[name="id"]');
        if (variant_select && variant_select.value) {
          frd_pdp_variant_id = parseInt(variant_select.value);
        } else {
          // Fall back to URL or default
        const url_parameters = new URLSearchParams(window.location.search);
          const url_variant_id = url_parameters.get('variant');
          frd_pdp_variant_id = url_variant_id ? parseInt(url_variant_id) : (frd_product.default_variant_id || product.variants[0].id);
        }
        
        let frd_pdp_variant = product.variants.find(function(variant){ return variant.id === frd_pdp_variant_id });
        const frd_pdp_variant_metafields = frd_product_variants_with_metafields[frd_pdp_variant_id] || {};
        const frd_pdp_variant_preorder_image = frd_pdp_variant_metafields ? frd_pdp_variant_metafields.preorder_image : undefined;
        const frd_pdp_variant_availability_date = frd_pdp_variant_metafields ? frd_pdp_variant_metafields.availability_date : undefined;
        const purchase_details_div = document.querySelector('.product .purchase-details');
        const active_available_date_div = document.querySelector('.metafield-available-date');
        const frd_pdp_variant_quantity = frd_pdp_variant_metafields ? frd_pdp_variant_metafields.quantity : undefined;

        if(frd_pdp_variant) {
          let frd_pdp_variant_title_text = frd_pdp_variant.title;
          let inseam_active = document.querySelector('.bold_option_set .bold_option_element .bold_option_value.active');

          if (frd_pdp_product_handle !== 'gift-card'){
            if(inseam_active) {
              let inseam_active_value = inseam_active.querySelector('.bold_option_value_title').textContent;
    
              frd_pdp_variant_title_text = `${frd_pdp_variant_title_text}<span id="inseamSize">x${inseam_active_value}</span>`;
            }
  
            // Update variant title. Re-query fresh and guard against null: the element
            // captured when frd_product_swatches() first ran can be removed/re-rendered
            // when switching colors (e.g. by BOLD), and throwing here aborts the rest of
            // this handler — so the update_variant()/Klaviyo button chain below never runs
            // for that color, leaving the Notify Me button stuck (works on one color, not
            // the other).
            const frd_pdp_variant_title_el = document.querySelector('.size-chart-grid-item-1 span') || frd_pdp_variant_title;
            if (frd_pdp_variant_title_el) {
              frd_pdp_variant_title_el.innerHTML = frd_pdp_variant_title_text;
            }
          }

          // Use the shared function to update button and div
          // Add a delay and retry mechanism to ensure select element and DOM are fully updated
          // This is especially important when switching colors, as the select might update slower
          const update_variant = function(attempt) {
            attempt = attempt || 0;
            // Re-check the select element AND URL to get the most current variant ID
            let current_variant_id = frd_pdp_variant_id;
            const current_select = document.querySelector('select[name="id"]');
            if (current_select && current_select.value) {
              current_variant_id = parseInt(current_select.value);
            } else {
              // Fall back to URL if select not updated yet
              const url_params = new URLSearchParams(window.location.search);
              const url_variant = url_params.get('variant');
              if (url_variant) {
                current_variant_id = parseInt(url_variant);
              }
            }
            
            // Only proceed if we have a valid variant ID
            if (current_variant_id && current_variant_id !== frd_pdp_variant_id) {
              // Variant ID changed - use the new one
              console.log('Variant ID changed from', frd_pdp_variant_id, 'to', current_variant_id, 'on attempt', attempt);
              frd_update_preorder_button_and_div(current_variant_id);
            } else if (current_variant_id) {
              // Same variant ID - proceed
              frd_update_preorder_button_and_div(current_variant_id);
            } else if (attempt < 5) {
              // Retry if variant ID not found yet
              setTimeout(function() { update_variant(attempt + 1); }, 150);
            } else {
              // Final fallback - use the original variant ID
              console.log('Using fallback variant ID:', frd_pdp_variant_id);
              frd_update_preorder_button_and_div(frd_pdp_variant_id);
            }
          };
          
          // Start with multiple attempts at different intervals
          setTimeout(function() { update_variant(0); }, 50);
          setTimeout(function() { update_variant(1); }, 200);
          setTimeout(function() { update_variant(2); }, 400);
          setTimeout(function() { update_variant(3); }, 600);
          
          // Check again after a delay to catch Klaviyo button that might appear dynamically
          setTimeout(function() {
            frd_hide_add_to_cart_if_klaviyo_visible();
          }, 300);
        }
      });
    });
    
    
  });
}

// Listen for variant selector changes (dropdown) to ensure button updates
window.addEventListener('load', function() {
  const variant_select = document.querySelector('select[name="id"]');
  if (variant_select) {
    variant_select.addEventListener('change', function() {
      const selected_variant_id = parseInt(this.value);
      if (selected_variant_id && !isNaN(selected_variant_id)) {
        // Small delay to ensure DOM is updated
        setTimeout(function() {
          frd_update_preorder_button_and_div(selected_variant_id);
        }, 100);
      }
    });
  }
});

function frd_product_inseam_swatches() {
  const inseam_variants = document.querySelectorAll('.bold_option_set .bold_option_element .bold_option_value');
  
  inseam_variants.forEach((inseam_variant, index) => {
    if (inseam_variant.dataset.frdInseamInitialized === 'true') {
      return;
    }

    inseam_variant.dataset.frdInseamInitialized = 'true';
    const inseam_radio = inseam_variant.querySelector('input[type="radio"]'); 
    const inseam_value = Number(inseam_radio.value);
    let inseamSize = document.querySelector('#inseamSize');
    let inseamSize_text = inseam_variant.querySelector('.bold_option_value_title').textContent;
    
    // Inseam click listener
    inseam_variant.addEventListener('click', (event) => {
      event.preventDefault();
  
      const active_inseam_variant = document.querySelector('.bold_option_set .bold_option_element .bold_option_value.active');
      let inseamSize = document.querySelector('#inseamSize');
      let inseamSize_text = inseam_variant.querySelector('.bold_option_value_title').textContent;
      const inseam_input = inseam_variant.querySelector('input[data-option_value_key]');
  
      // If an inseam is active
      if(active_inseam_variant) {
        active_inseam_variant.classList.remove('active');
      }

      // Set clicked inseam as active
      inseam_variant.classList.add('active');
  
      // If old inseam size
      if(inseamSize) {
        // Remove old inseam size
        inseamSize.remove();
      }
      
      // Append variant/option header text
      $('.size-chart-grid-item-1 span').append('<span id="inseamSize">x' + inseamSize_text + '</span>');

      // Check inseam input
      inseam_input.checked = true;
    });

    // Set 32 as active by default
    if(inseam_value === 32) {
      // Add "active" class
      inseam_variant.classList.add('active');

      // Check inseam input
      inseam_radio.checked = true;

      // Append variant/option header text
      $('.size-chart-grid-item-1 span').append('<span id="inseamSize">x' + inseamSize_text + '</span>');
    }
  });
}

if (window.BOLD && BOLD.common && BOLD.common.eventEmitter) {
  BOLD.common.eventEmitter.on('BOLD_OPTIONS_option_products_loaded', function() {
    frd_product_inseam_swatches();
  });
}
